// NOTE: enum for feature flags from GrowthBook
export enum EFeatureName {
  FEATURE_SUBSCRIPTION_FREEZE = 'feature_subscription_freeze',
  FEATURE_SKIP_THIS_MONTH = 'feature_skip_this_month',
  MEMBERSHIP_CARD = 'membership_card',
}
